import { createContext } from "react";

const Contexto=createContext();

export default Contexto;